import { FunctionComponent } from "react";
import { SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import ModalFilter from "./modalFilter";
import SearchInput from "../../../../components/inputs/searchInput";
import { useServicesMembrosCheckin } from "../context/getMembros";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";


interface HeaderCheckinMembrosProps {

}

const HeaderCheckinMembros: FunctionComponent<HeaderCheckinMembrosProps> = () => {

  const { listAll, getWithParams, getSearchNome, reset } = useServicesMembrosCheckin()

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>
        <ModalExportar
          callDownloadExcel={() => OpenExcelUniversal(listAll, ["nome", "email", "telefone", "nomeevento", "igreja_origem", "batizado", "ministerio_desejado", "inscricao"])}
          callDownloadPdf={() => DonwloadPdf(listAll, ["Nome", "Email", "Telefone", "Evento", "Igreja Origem", "Batizado", "Ministério", "Inscrição"],
            ["nome", "email", "telefone", "nomeevento", "igreja_origem", "batizado", "ministerio_desejado", "inscricao"], listAll?.length, [], `${listAll?.length}`)
          }
        />
        <ModalFilter reset={reset} getConexao={(e) => getWithParams(e)} />
      </section>
      <SearchInput placeholder="Procure por nome" onChange={getSearchNome} />
      <section />
    </SecaoButao>
  </>);
}

export default HeaderCheckinMembros;
